import { render } from "./XdDetail.vue?vue&type=template&id=7c99d166&scoped=true"
import script from "./XdDetail.vue?vue&type=script&lang=js"
export * from "./XdDetail.vue?vue&type=script&lang=js"

import "./XdDetail.vue?vue&type=style&index=0&id=7c99d166&lang=less&scoped=true"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c99d166"]])

export default __exports__